// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { ScheduleItemCalendarResponse } from './schedule-item-calendar-response';

/** See com.rev360.pms.api.controller.schedule.scheduleitem.calendar.ScheduleItemsWithDeletedResponse */
/* istanbul ignore next */
@GandalfModel
export class ScheduleItemsWithDeletedResponse extends GandalfModelBase {

	@GandalfArray(Number)
	deletedScheduleItems!: number[] | null;

	@GandalfArray(ScheduleItemCalendarResponse)
	scheduleItemCalendarResponses!: ScheduleItemCalendarResponse[] | null;

}
